import React from "react";
import { HelpCircle, Info } from "lucide-react";

const QA = [
  { q: "Can I sell my land later?",           a: "Yes — fully yours to keep, sell, or gift." },
  { q: "What if I can't pay one month?",      a: "Pause up to 12 months — no penalties, no lost progress." },
  { q: "Can I buy for my child?",             a: "Yes — add them as heir or joint owner directly on the deed." },
  { q: "Do I need my own lawyer?",            a: "We provide an independent Title Guardian. You can also bring your own." },
];

export default function QuickQuestionsBand() {
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="quick-questions-band">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Quick Answers</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          The four questions <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>everyone asks first.</span>
        </h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {QA.map((c, i) => (
            <div key={c.q} className="mv-card p-6" data-testid={`quick-qa-${i}`}>
              <div className="flex items-start gap-3">
                <HelpCircle size={20} className="mv-green-text shrink-0" style={{ color: "var(--mv-gold)" }}/>
                <div>
                  <div className="font-display text-[16.5px] mv-green-text">{c.q}</div>
                  <p className="mt-2 text-[14px]" style={{ color: "var(--mv-muted)" }}>{c.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6 flex items-center gap-2 text-[13px]" style={{ color: "var(--mv-muted)" }}>
          <Info size={13}/> More detail lives on the <a href="/faq" className="underline mv-green-text">full FAQ</a>.
        </div>
      </div>
    </section>
  );
}
